import reqQuote from '@/views/reqQuote/local/zh'
import components from '@/components/local/zh'
export default {
  route: {
    dashboard: '首页',
    introduction: '简述',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    menu1: '菜单1',
    'menu1-1': '菜单1-1',
    'menu1-2': '菜单1-2',
    'menu1-2-1': '菜单1-2-1',
    'menu1-2-2': '菜单1-2-2',
    'menu1-3': '菜单1-3',
    menu2: '菜单2',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Table内编辑',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    example1: '示例1',
    systemAnalysis: '系统分析',
    customerInformation: '客户信息',
    quotationInquiry: '报价申请查询',
    createANew: '新建报价申请',
    modifyTheQuote: '修改报价申请',
    historicalData: '报价申请历史数据',
    createANewPittedPaper: '新建报价申请(坑纸)',
    quotation: '报价单',
    productSettings: '产品配置',
    quotedProcessParameters: '报价工艺参数',
    cableSetting: '拉线类型界定设置',
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤'
  },
  login: {
    title: '旺盈集团报价系统',
    logIn: '登录系统',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
    selectCompany: '请选择公司',
    enterUserName: '请输入用户名',
    enterPassword: '请输入密码',
    remember_the_password: '记住密码',
    userNameHint: '用户名由5-20位字母或数字组成',
    passwordHint: '密码不能小于5位'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    Copy: '复制',
    Hint: '提示',
    Delete_this_data: '是否删除此数据',
    Delete_success: '删除成功',
    Delete_fail: '删除失败',
    The_deletion_was_canceled: '已取消删除',
    Modify: '修改',
    View: '查看',
    Upload: '上传',
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  quoteCommon: {
    search: '查询',
    new: '新建',
    pleaseEnter: '请输入',
    Input_format: '输入格式',
    Application_form_number: '申请单号',
    Estimate_No: '估价单号',
    Customer_number: '客户编号',
    Customer_name: '客户名称',
    Product_number: '产品编号',
    Product_size: '产品尺寸',
    Product_name: '产品名称',
    Number_of_products: '产品数量',
    Please_select: '请选择',
    Whole: '全部',
    Not_approved: '未批核',
    Approved: '已批核',
    Replied: '已回复',
    No_reply: '未回复',
    Status: '状态',
    typeOfGoods: '货品种类',
    Please_enter_a_keyword: '请输入关键字',
    Please_enter_customer_information_first: '请先输入客户信息',
    The_user_has_no_permission_to_view_the_quotation_information_of_this_customer: '用户没有该客户报价信息的查看权限',
    Details: '详情',
    Remark: '备注',
    Quotation: '报价',
    More: '更多',
    Submit: '提交',
    Number: '编号',
    Name: '名称',
    Choose: '选择',
  },
  analyze: {
    title: '部门/天/开单量',
    pitCarton: '坑纸箱',
    bookEdition: '书版类',
    colorBox: '彩盒类',
    boutiqueBox: '精品盒',
    woodenBox: '木盒',
  },
  quoteQuery: {
    no: '单号',
    pleaseEnter: '输入申请单号或估价单号',
    startDate: '开始日期',
    endDate: '结束日期',
    myOrder: '我的单',
    moreConditions: '更多条件',
    newPitCarton: '新建坑纸箱',
    businessDepartment: '营业部门',
    creationTime: '创建时间',
    Created_by: '创建人',
    Quotation_clerk: '报价员',
    Application_status: '申请状态',
    Valuation_status: '估价状态',
    Ergonomic_information: '工效信息',
    Inquiry_information: '询价信息',
  },
  reqQuote,
  components
}



// WEBPACK FOOTER //
// ./src/lang/zh.js